import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import { getClickTrackersInfo, GetTickets } from '../../api';
import MyTickets from '../Home/MyTickets';
import style from './Grievance.module.scss';
import { FaqWrapper } from '../common';
import { env, getContractTypeVal, getCookie, getProjectId, trackUserType, allVerticalsParam } from '../../lib/common';
import NoDataView from '../../pages/NoDataView';

function Grievance() {
  const [authState] = useAuth();
  const { type, userDetails } = authState;
  const projectId = getProjectId();
  const contractType = getContractTypeVal(projectId);
  const [myTicketsLoading, setMyTicketsLoading] = useState(true);
  const [myTicketsData, setMyTicketsData] = useState([]);
  const [selectedGrievance, setSelectedGrievance] = useState('Grievance Level 1');
  const selectedBusiness = JSON.parse(localStorage.getItem('selectedBusiness'));
  const contractVal = getContractTypeVal('csportal');

  const getTicketsData = async (grievanceType = '') => {
    try {
      setMyTicketsLoading(true);
      const docIdObj = {
        docId: selectedBusiness?.docid || '',
      };
      const portalFlag = 1;
      const params = {
        category: 'CS',
        vertical: allVerticalsParam,
        allocEmpid: '',
        page: 1,
        limit: 20,
        search: docIdObj,
        sortBy: '',
        ticketCreator: '',
        download: 0,
        portalFlag,
        emails: undefined,
        _status: 'Grievance Redressal',
        ticketId: '',
        genioMyTicketsFlag: '',
      };
      if (grievanceType === 'Grievance Level 2') {
        params.gr_raised = 1;
      }
      const res = await GetTickets(params);
      setMyTicketsData(res?.data?.length > 0 ? res?.data || [] : []);
    } catch (error) {
      console.log('error', error);
    }
    setMyTicketsLoading(false);
  };

  const reloadMyTickets = async () => {
    try {
      await getTicketsData('Grievance Level 1');
    } catch (e) {
      console.error('Error fetching tickets while reloading', e);
    }
  };

  const isBusinessActive = () => type === 'business' && selectedBusiness.active && selectedBusiness.paidstatus === 1;

  const handleGetTicketsData = async () => {
    if (type === 'business') {
      getTicketsData('Grievance Level 1');
    }
  };

  useEffect(() => {
    if (type) {
      handleGetTicketsData();
    }
  }, [type]);

  const handleSelectedGrievence = (grievanceType) => {
    setSelectedGrievance(grievanceType);
    getTicketsData(grievanceType);
  };

  const handleOnLanding = async (liVal = '', liTrd = '', faqTypeVal = '', othersData = []) => {
    try {
      let sessionId = getCookie('session_id');
      if (!sessionId) {
        sessionStorage.setItem('session_id', sessionId);
      }
      if (!sessionId) {
        sessionId = Math.random().toString(36).slice(2);
        document.cookie = `session_id=${sessionId}; path=/;`;
        sessionStorage.setItem('session_id', sessionId);
      }
      if (sessionId) {
        const jduId = userDetails?.jduid || '';
        const sectionOthersData = othersData?.map((item) => item.title);

        const trdObj = {
          cname: selectedBusiness?.compname || '',
          cta_name: '',
          docid: selectedBusiness?.docid || '',
          city: selectedBusiness?.city || '',
          dcity: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pin: selectedBusiness?.pincode || '',
          ds: '',
          pdg: '',
          paid: selectedBusiness?.paidstatus || '',
          usertype: authState?.sidResponse ? `${trackUserType?.[contractType]}` : 'non_login',
          jd_verified: '',
          guarantee: '',
          trust: '',
          verified: '',
          tag: '',
          pos: '',
          li: liTrd,
          sections: [],
        };
        if (liTrd === 'landing') {
          trdObj.sections = [];
          trdObj.cta_name = ['Chat with Us', 'Get a Callback'];
        }
        if (liVal === 'click') {
          trdObj.sections = faqTypeVal === 'Others' ? sectionOthersData : '';
          trdObj.cta_name = '';
        }

        const paramsData = {
          session_id: sessionId,
          search_id: sessionId,
          trd: [trdObj],
          li: liVal,
          ll: 'cshmpg',
          referrer: 'auto',
          user_ip: '',
          city: selectedBusiness?.city || '',
          data_city: selectedBusiness?.data_city || '',
          area: selectedBusiness?.areaname || '',
          pincode: selectedBusiness?.pincode || '',
          jduid: jduId || '',
          mobile: userDetails?.mobile || '',
          request_time: '',
          device_src: getCookie('device_src') || '2',
          device_id: '',
          category_name: '',
          user_agent: '',
          sid: getCookie('sid') || '',
          jde: '',
          vid: '615',
          env,
          utm_source: '',
          utm_medium: '',
          utm_campaign: '',
          app_version: '',
          transaction_id: '',
        };
        await getClickTrackersInfo(paramsData);
      }
    } catch (err) {
      console.log('ERROR in handleClickTrackers', err);
    }
  };
  return (
    <>
      {(!authState?.sidResponse && !selectedBusiness?.docid) || (selectedBusiness?.docid && contractVal === 'free') ? (
        <NoDataView pageName="Grievance Tickets" />
      ) : (
        <>
          <div className={`${style.Tab} mt-10`}>
            <ul className={`${style.TabList}`}>
              {['Grievance Level 1', 'Grievance Level 2'].map((each, idx) => (
                <li key={idx} className={`${style.TabItem} ${each === selectedGrievance ? style.Active : ''}`}>
                  <div
                    onClick={() => handleSelectedGrievence(each)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => {}}
                    className={`${style.TabAnchor} font14 fw500`}
                  >
                    {each}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          {isBusinessActive() && (
            <MyTickets
              reloadMyTickets={reloadMyTickets}
              loading={myTicketsLoading}
              myTicketsData={myTicketsData}
              id="grievance"
              selectedGrievance={selectedGrievance}
              handleOnLanding={handleOnLanding}
            />
          )}
        </>
      )}
    </>
  );
}

export default FaqWrapper(Grievance);
